module.exports = __webpack_public_path__ + "public/Icons/darkModeOff.svg?7d994297";